import React, { useEffect, useState } from 'react';
import { ElectionContentBox, useElectionMenuItems } from 'components/Temporary/Election2024';
import ElectionSectionTitle from 'components/Temporary/ElectionSectionTitle';
import { useLocation } from 'react-router-dom';
import useAddMetaTags from 'components/Dashboard/utilities/addMetaTags';
import ManifestosSearch from 'components/Temporary/Manifestos/ManifestosSearch';
import ManifestoShare from 'components/Temporary/Manifestos/ManifestoShare';
import RateLimitManifestos from 'components/Temporary/Manifestos/RateLimitManifestos';

const Manifestos = () => {
  const location = useLocation();

  const [activeTab, setActiveTab] = useState('Analysis');
  const [comparison, setComparison] = useState(null);
  const [election2026Tab, setElection2026Tab] = useState('senedd');
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const { addMetaTags } = useAddMetaTags();
  const { election2026, manifestosData } = useElectionMenuItems();

  useEffect(() => {
    addMetaTags({ title: 'Explore manifestos - Election hub - PolicyMogul', hash: location.hash });
    if (location.hash.includes('holyrood')) setElection2026Tab('holyrood');
  }, []);

  const manifestosToRender = election2026 ? manifestosData[election2026Tab] : manifestosData;

  return (
    <>
      <ElectionContentBox
        header={
          <ManifestosHeader
            comparisonState={{ comparison, setComparison }}
            activeTabState={{ activeTab, setActiveTab }}
            election2026TabState={{ election2026Tab, setElection2026Tab }}
          />
        }
      >
        <div className='manifestos-container h-100'>
          {activeTab === 'Analysis' ? (
            <ManifestosSearch
              openState={{ isOpen, setIsOpen }}
              comparisonState={{ comparison, setComparison }}
              election2026TabState={{ election2026Tab, setElection2026Tab }}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
            />
          ) : (
            <div className='py-4 px-3 px-lg-5 pb-3'>
              {manifestosToRender.map((item) => {
                const { label, link, image } = item;
                return (
                  <div className={`manifestos-item`} key={label}>
                    <img
                      src={`${import.meta.env.VITE_APP_CDNURL}/images/manifesto/${image}-manifesto.png`}
                      alt={label}
                      className={`manifesto-image manifesto-${image}`}
                    />
                    <div className='flex-column'>
                      <h5 className='title-h5-bold'>{label} manifesto</h5>
                      <p className='paragraph-p1'>
                        {link ? (
                          <a href={link} className='simple-link-text' target={'_blank'} rel='noopener noreferrer'>
                            The {label} manifesto is available here
                          </a>
                        ) : (
                          <span>When the {label} manifesto is announced it will be available here.</span>
                        )}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </ElectionContentBox>
      <RateLimitManifestos openState={{ isOpen, setIsOpen }} />
    </>
  );
};

const ManifestosHeader = (props) => {
  const { activeTabState, comparisonState, election2026TabState } = props;
  const { comparison } = comparisonState ?? {};
  const { activeTab, setActiveTab } = activeTabState ?? {};
  const { election2026 } = useElectionMenuItems();
  const { election2026Tab, setElection2026Tab } = election2026TabState ?? {};
  const tabs = ['Analysis', 'Read manifestos'];
  const election2026Tabs = ['Senedd', 'Holyrood'];

  return (
    <>
      <div className='election-keyupdates-header'>
        <ElectionSectionTitle title={'Explore manifestos'} />
        {!!comparison ? (
          <ManifestoShare />
        ) : (
          <div className='flex-centered manifesto-tabs'>
            {tabs.map((item) => {
              return (
                <button
                  key={`tab-${item}`}
                  className={`general-button px-2 px-lg-4 nowrap-item rounded mr-2 ml-lg-2 mr-lg-0 ${item === activeTab ? 'action-button' : 'bg-main-white border action-state-hover'}`}
                  onClick={() => {
                    setActiveTab(item);
                  }}
                >
                  {item}
                </button>
              );
            })}
          </div>
        )}
      </div>
      {election2026 && (
        <div className='flex-centered pt-3 gap-10'>
          {election2026Tabs.map((tab) => (
            <button
              key={tab}
              className={`rounded-pill border px-4 py-1 general-button ${tab.toLowerCase() === election2026Tab ? 'text-light-blue bg-blue-hovered' : 'border action-state-hover'}`}
              onClick={() => setElection2026Tab(tab.toLowerCase())}
            >
              {tab} manifestos
            </button>
          ))}
        </div>
      )}
    </>
  );
};

export default Manifestos;
